import React, { useEffect, useState } from "react";
import { ConfigProvider, Table, message } from "antd";
import DashboardProvider from "../../../../../../shared/provider/DashboardProvider";
import { IdeaFinishedDTO } from "../../../../../../shared/dto/IdeaFinishedDTO";
import ptBR from "antd/lib/locale/pt_BR";

const columns = [
  {
    title: 'ID',
    dataIndex: 'ideaId',
    key: 'ideaId',
    sorter: (a: IdeaFinishedDTO, b: IdeaFinishedDTO) => a.ideaId - b.ideaId,
  },
  {
    title: 'Fase',
    dataIndex: 'stageName',
    key: 'stageName',
    sorter: (a: IdeaFinishedDTO, b: IdeaFinishedDTO) => a.stageName.localeCompare(b.stageName),
  },
  {
    title: 'Título',
    dataIndex: 'ideaTitle',
    key: 'ideaTitle',
    sorter: (a: IdeaFinishedDTO, b: IdeaFinishedDTO) => a.ideaTitle.localeCompare(b.ideaTitle),
  },
  {
    title: 'Data de conclusão',
    dataIndex: 'finishedAt',
    key: 'finishedAt',
    sorter: (a: IdeaFinishedDTO, b: IdeaFinishedDTO) => new Date(a.finishedAt).getTime() - new Date(b.finishedAt).getTime(),
    render: (date: string) => new Date(date).toLocaleDateString(),
  },
];

function FinishedIdeasList({ dataUpdater }: {dataUpdater: React.Dispatch<React.SetStateAction<IdeaFinishedDTO[]>>}): JSX.Element {
  const [data, setData] = useState<IdeaFinishedDTO[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const dashboardProvider = new DashboardProvider();
      try {
        const response = await dashboardProvider.getIdeasFinished();
        setData(response);
      } catch (error) {
        message.error("Erro ao buscar dados de ideias concluídas");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    dataUpdater(data);
  }, [data, dataUpdater]);

  return (
    <ConfigProvider locale={ptBR}>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        rowKey="ideaId"
        />
    </ConfigProvider>
  );
}

export default FinishedIdeasList;
